"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Aggregate = void 0;
const types_1 = require("@comunica/types");
class Aggregate {
    name;
    expression;
    expressionType = types_1.ExpressionType.Aggregate;
    constructor(name, expression) {
        this.name = name;
        this.expression = expression;
    }
}
exports.Aggregate = Aggregate;
//# sourceMappingURL=Aggregate.js.map